// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0746e007","513":"da693983","703":"03239586","787":"a48df1bf"}[chunkId] + ".chunk.js";
};